import {
  Box,
  Card,
  CardContent,
  Grid
} from "@material-ui/core";
import React from "react";
import "./FinancialTableGrid.less";
import { checkNegative } from "../../../../utils/generic";

class FinancialTableGrid extends React.Component {
  constructor() {
    super();

    this.state = {
      dataList: [],
      datacenterList: [],
      siteProfileList: []
    };
  }

  componentDidMount() {
    this.setListData();
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.listData !== newProps.listData ||
      this.props.datacenterList !== newProps.datacenterList ||
      this.props.siteProfileList !== newProps.siteProfileList ||
      this.props.startDate !== newProps.startDate
    ) {
      this.setState({
        dataList: newProps.listData,
        datacenterList: newProps.datacenterList,
        siteProfileList: newProps.siteProfileList
      });
    }
  }

  /** set data */
  setListData() {
    this.setState({
      dataList: this.props.listData,
      datacenterList: this.props.datacenterList,
      siteProfileList: this.props.siteProfileList
    });
  }
  /** Search property Name */
  _searchPropertyName(nameKey, myArray) {
    if (myArray != undefined) {
      for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].dwPropertyId == nameKey) {
          return myArray[i].name;
        }
      }
    }
  }

  /** Search capacity */
  _searchCapacity(nameKey, propertyKey, myArray) {
    if (myArray != undefined) {
      const dataSource = (myArray || []).filter(
        x => x.AttributeName == nameKey && x.DwPropertyId == propertyKey
      );
      if (dataSource.length == 0) {
        return "-";
      }
      for (let i = 0; i < myArray.length; i++) {
        if (
          myArray[i].AttributeName == nameKey &&
          myArray[i].DwPropertyId == propertyKey
        ) {
          return myArray[i].Power !== null
            ? parseFloat(myArray[i].Power).toLocaleString()
            : "-";
        }
      }
    }
  }

  render() {
    return (
      <Grid container spacing={1} className={"financial-grid-content"}>
        {(this.state.dataList || []).map((item, index) => (
          <Grid item xs={12} md={4} sm={6} key={"grid_container" + index}>
            <Box>
              <Card
                onClick={() =>
                  this.props.PropertyDetailViewSection
                    ? this.props.getPropertyDetail(item[0].propertyKey)
                    : console.log("No Access")}
                style={{ cursor: "pointer" }}
              >
                <div className={"card-header-financial"}>
                  {this._searchPropertyName(
                    item[0].propertyKey,
                    this.state.datacenterList
                  )}
                </div>
                <CardContent className={"card-body-financial"}>
                  <table className={"card-table-financial"}>
                    <tbody>
                      <tr>
                        <th className={"w-40"} style={{ textAlign: "left" }} />
                        <th className={"w-30"}>{"Month To Date"}</th>
                        <th className={"w-30"}>{"Year To Date"}</th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "left" }}>{"NOI Budgeted ($)"}</th>
                        <td>
                          {checkNegative(
                            (
                              item.find(x => x.attributeType == "MTDBudget") ||
                              {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                        <td>
                          {checkNegative(
                            (
                              item.find(x => x.attributeType == "YTDBudget") ||
                              {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "left" }}>{"NOI Actual ($)"}</th>
                        <td>
                          {checkNegative(
                            (
                              item.find(x => x.attributeType == "MTDActual") ||
                              {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                        <td>
                          {checkNegative(
                            (
                              item.find(x => x.attributeType == "YTDActual") ||
                              {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "left" }}>{"NOI Variance ($)"}</th>
                        <td>
                          {checkNegative(
                            (
                              item.find(
                                x => x.attributeType == "MTDVarianceAmt"
                              ) || {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                        <td>
                          {checkNegative(
                            (
                              item.find(
                                x => x.attributeType == "YTDVarianceAmt"
                              ) || {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "left" }}>{"NOI Variance (%)"}</th>
                        <td>
                          {checkNegative(
                            (
                              item.find(
                                x => x.attributeType == "MTDVariancePerct"
                              ) || {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                        <td>
                          {checkNegative(
                            (
                              item.find(
                                x => x.attributeType == "YTDVariancePerct"
                              ) || {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr style={{ marginTop: "1px", marginBottom: "1px" }} />
                  <table className={"card-table-financial"}>
                    <tbody>
                      <tr>
                        <th className={"w-40"} style={{ textAlign: "left" }}>
                          {"Cash On Hand ($)\r"}
                        </th>
                        <td className={"w-30"}>
                          {checkNegative(
                            (
                              item.find(x => x.attributeType == "CashOnHand") ||
                              {}
                            ).attributeValue
                          ).toLocaleString()}
                        </td>
                        <td className={"w-30"} />
                      </tr>
                      <tr>
                        <th className={"w-40"} style={{ textAlign: "left" }}>
                          {"Installed Capacity (kW)\r"}
                        </th>
                        <td className={"w-30"}>
                          {this._searchCapacity(
                            "Total Capacity",
                            item[0].propertyKey,
                            this.state.siteProfileList
                          )}
                        </td>
                        <td className={"w-30"} />
                      </tr>
                      <tr>
                        <th style={{ textAlign: "left" }}>
                          {"Leased Capacity (kW)\r"}
                        </th>
                        <td>
                          {" "}
                          {this._searchCapacity(
                            "Leased Capacity",
                            item[0].propertyKey,
                            this.state.siteProfileList
                          )}
                        </td>
                        <td />
                      </tr>
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default FinancialTableGrid;
